import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {searchFormActions, searchFormSlice} from "../slices/search_form_slice";

export const useSearchForm = () => {
    const dispatch = useDispatch();
    const isLocationSearchOpen = useSelector((state: IRPStore) => state.search[searchFormSlice.name].isLocationSearchOpen);

    const openLocationSearch = () => {
        dispatch(searchFormActions.openLocationSearch());
    };

    const closeLocationSearch = () => {
        dispatch(searchFormActions.closeLocationSearch());
    };

    const setLocationSearchOpenStatus = (isOpen: boolean) => {
        if (isOpen) {
            openLocationSearch();
        } else {
            closeLocationSearch();
        }
    };

    const toggleLocationSearch = () => {
        setLocationSearchOpenStatus(!isLocationSearchOpen);
    };

    return {
        isLocationSearchOpen,
        openLocationSearch,
        toggleLocationSearch,
        setLocationSearchOpenStatus
    };
};
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {searchFormActions, searchFormSlice} from "../slices/search_form_slice";

export const useSearchForm = () => {
    const dispatch = useDispatch();
    const isLocationSearchOpen = useSelector((state: IRPStore) => state.search[searchFormSlice.name].isLocationSearchOpen);

    const openLocationSearch = () => {
        dispatch(searchFormActions.openLocationSearch());
    };

    const closeLocationSearch = () => {
        dispatch(searchFormActions.closeLocationSearch());
    };

    const setLocationSearchOpenStatus = (isOpen: boolean) => {
        if (isOpen) {
            openLocationSearch();
        } else {
            closeLocationSearch();
        }
    };

    const toggleLocationSearch = () => {
        setLocationSearchOpenStatus(!isLocationSearchOpen);
    };

    return {
        isLocationSearchOpen,
        openLocationSearch,
        toggleLocationSearch,
        setLocationSearchOpenStatus
    };
};
